import { useSelector } from "@xstate/store-react";
import { panelStore } from "@/app/providers/panel-store";
import { appointmentDetailStore } from "./appointment-detail-store";

export const useSelectedAppointmentId = () => useSelector(appointmentDetailStore, (s) => s.context.visitId);

export const useAppointmentPanelOpen = () => useSelector(panelStore, (s) => s.context.activePanel === "detail");

export const useDetailScheduleId = () => useSelector(appointmentDetailStore, (s) => s.context.scheduleId);

export const useAppointmentDetailActions = () => ({
  openDetail: (visitId: string, scheduleId?: string) => {
    panelStore.send({ type: "panel.open", panel: "detail" });
    appointmentDetailStore.send({ type: "appointment.select", visitId, scheduleId });
  },
  closeDetail: () => {
    panelStore.send({ type: "panel.close" });
  },
});
